export default __webpack_public_path__ + "static/img/robbins-medical.bb6afd5.jpg";